import {
    HiOutlineViewGrid,
    
    HiOutlineUser,
    HiOutlineReceiptTax

} from 'react-icons/hi'

import { MdAdminPanelSettings } from "react-icons/md";

export const DASHBOARD_SIDEBAR_LINKS = [
    {
        key: 'dashboard',
        label: 'Dashboard',
        path: '/',
        icon:  <HiOutlineViewGrid />
    },
    {
        key: 'reps',
        label: 'Reps',
        path: '/reps',
        icon:  <HiOutlineUser />
    },
    {
        key: 'recipts',
        label: 'Recipts',
        path: '/recipts',
        icon:  <HiOutlineReceiptTax />
    },
    {
        key: 'admins',
        label: 'Admins',
        path: '/admins',
        icon: <MdAdminPanelSettings />
    },
    
    

    
    
]
